export default __webpack_public_path__ + "static/media/loc_img_8.06b37944.jpg";